var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("PageLayoutForms", {
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function() {
          return [
            _c(
              "h1",
              {
                staticClass:
                  "pdp-mandate-onboarding-electronic-address__title typographies-heading-h1"
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t.__("pdp.mandate.Onboarding.title")) +
                    "\n        "
                )
              ]
            )
          ]
        },
        proxy: true
      },
      {
        key: "content",
        fn: function() {
          return [
            _c("InformationBanner", {
              attrs: {
                title: _vm.$t.__(
                  "pdp.mandate.OnboardingElectronicAddress.InformationBanner.title"
                ),
                sourceIllustration:
                  "/ressources/logged/img/illustrations/pdp/receipt-purchases.svg"
              },
              scopedSlots: _vm._u([
                {
                  key: "description",
                  fn: function() {
                    return [
                      _c("div", {
                        staticClass:
                          "pdp-mandate-onboarding-electronic-address__information typographies-paragraph-medium-regular",
                        domProps: {
                          innerHTML: _vm._s(_vm.informationBannerDescription)
                        }
                      })
                    ]
                  },
                  proxy: true
                }
              ])
            }),
            _vm._v(" "),
            _c(
              "h2",
              {
                staticClass:
                  "pdp-mandate-onboarding-electronic-address__subtitle typographies-heading-h2"
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.$t.__(
                        "pdp.mandate.OnboardingElectronicAddress.subtitle"
                      )
                    ) +
                    "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "pdp-mandate-onboarding-electronic-address__choices"
              },
              _vm._l(["sellsy", "other"], function(choice) {
                return _c("OnboardingChoice", {
                  key: choice,
                  attrs: { type: choice, state: _vm.choiceState(choice) },
                  on: { select: _vm.handleChoiceSelection }
                })
              }),
              1
            ),
            _vm._v(" "),
            _vm.selectedAddressType
              ? _c(
                  "div",
                  {
                    staticClass:
                      "pdp-mandate-onboarding-electronic-address__creation"
                  },
                  [
                    _c(
                      "h3",
                      { staticClass: "typographies-paragraph-large-semibold" },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.$t.__(
                                "pdp.mandate.OnboardingElectronicAddress.creation.title"
                              )
                            ) +
                            "\n            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "pdp-mandate-onboarding-electronic-address__creation-wrapper typographies-paragraph-medium-regular"
                      },
                      [
                        !_vm.editMode
                          ? [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "pdp-mandate-onboarding-electronic-address__creation-value"
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.placeholder) +
                                      "\n                    "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("CompassIconButton", {
                                attrs: { icon: "edit" },
                                on: { click: _vm.toggleEditMode }
                              })
                            ]
                          : [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "pdp-mandate-onboarding-electronic-address__creation-prefix"
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.formattedSiren) +
                                      "_\n                    "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "CompassFormItem",
                                {
                                  staticClass:
                                    "pdp-mandate-onboarding-electronic-address__creation-input",
                                  attrs: {
                                    label: "",
                                    error: _vm.isError ? _vm.errorMessage : ""
                                  }
                                },
                                [
                                  _c("CompassInput", {
                                    ref: "inputElectronicAddress",
                                    attrs: {
                                      placeholder: _vm.inputPlaceholder,
                                      error: _vm.isError
                                    },
                                    nativeOn: {
                                      keyup: [
                                        function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.validateElectronicAddress(
                                            $event
                                          )
                                        },
                                        function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "esc",
                                              27,
                                              $event.key,
                                              ["Esc", "Escape"]
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.toggleEditMode($event)
                                        }
                                      ]
                                    },
                                    model: {
                                      value: _vm.temporaryElectronicAddress,
                                      callback: function($$v) {
                                        _vm.temporaryElectronicAddress = $$v
                                      },
                                      expression: "temporaryElectronicAddress"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("CompassIconButton", {
                                attrs: {
                                  icon: "close",
                                  disabled: _vm.isCancelButtonDisabled
                                },
                                on: { click: _vm.toggleEditMode }
                              }),
                              _vm._v(" "),
                              _c("CompassIconButton", {
                                attrs: {
                                  icon: "check",
                                  type: "primary",
                                  disabled: _vm.isValidateButtonDisabled
                                },
                                on: { click: _vm.validateElectronicAddress }
                              })
                            ]
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "pdp-mandate-onboarding-electronic-address__creation-information typographies-paragraph-medium-regular"
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.creationInformation) +
                            "\n            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("CompassPlainButton", {
                      attrs: {
                        label: _vm.$t.__(
                          "pdp.mandate.OnboardingElectronicAddress.support_button"
                        )
                      },
                      on: { click: _vm.goToFAQ }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [
            _c("FooterFullPage", {
              attrs: {
                primaryAction: _vm.primaryAction,
                secondaryActions: _vm.secondaryActions
              }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }